import React from "react";
import { Route, Switch, useRouteMatch } from "react-router-dom";
import CobrandTagsDefaultPage from "./Pages/CobrandTagsDefaultPage";
import CobrandTagsWizardPage from "./Pages/CobrandTagsWizardPage";

function CobrandTagsRouter() {
    let { path } = useRouteMatch();

    return (
        <Switch>
            <Route path={`${path}/wizard`}>
                <CobrandTagsWizardPage />
            </Route>
            <Route path={`${path}/:cobrandTagId/wizard`}>
                <CobrandTagsWizardPage />
            </Route>
            <Route default>
                <CobrandTagsDefaultPage />
            </Route>
        </Switch>
    );
}

export default CobrandTagsRouter;
